(function () {

  function normalizeString(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")                 // split diacritics
      .replace(/[\u0300-\u036f]/g, "")  // remove diacritics
      .replace(/[^a-z0-9\s]/g, "")      // remove special chars incl ® ™ etc
      .replace(/\s+/g, " ");            // normalize whitespace
  }

  function getCurrentVariantId() {
    const input =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"][type="hidden"]');

    if (input && input.value) {
      return String(input.value);
    }

    const params = new URLSearchParams(window.location.search);
    return params.get("variant");
  }

  // Reglerne indlæses fra assets/pdp-delivery-rules.json ved sideindlæsning.
  // Indtil de er hentet (eller hvis hentning fejler) er denne null, og
  // updateInventoryMessage falder tilbage til de indbyggede DEFAULT_RULES.
  let LOADED_RULES = null;

  function loadRules() {
    const el = document.getElementById("pdp-location-inventory");
    const url = el && el.dataset.rulesUrl;
    if (!url) return Promise.resolve();

    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(data => {
        if (
          data &&
          typeof data === "object" &&
          !Array.isArray(data) &&
          Object.keys(data).length
        ) {
          LOADED_RULES = data;
        } else {
          throw new Error("Tom eller ugyldig regelfil");
        }
      })
      .catch(err => {
        // Diskret signal: kun i konsollen, intet synligt for kunderne.
        LOADED_RULES = null;
        console.warn(
          "[pdp-location-inventory] Kunne ikke indlæse pdp-delivery-rules.json – " +
            "bruger indbyggede standardregler (fallback):",
          (err && err.message) || err
        );
      });
  }

  function updateInventoryMessage() {
    const el = document.getElementById("pdp-location-inventory");
    if (!el) return;

    const vendor = normalizeString(el.dataset.vendor);

    let variantLocationsMap = {};
    try {
      variantLocationsMap = JSON.parse(el.dataset.variantLocations || "{}");
    } catch {
      variantLocationsMap = {};
    }

    let variantLeveringstidMap = {};
    try {
      variantLeveringstidMap = JSON.parse(el.dataset.variantLeveringstid || "{}");
    } catch {
      variantLeveringstidMap = {};
    }

    const currentVariantId = getCurrentVariantId();

    const leveringstid = currentVariantId ? variantLeveringstidMap[String(currentVariantId)] : null;
    if (leveringstid) {
      el.textContent = leveringstid;
      return;
    }

    let locations = [];
    const raw = currentVariantId
      ? variantLocationsMap[String(currentVariantId)]
      : null;

    if (Array.isArray(raw)) {
      locations = raw
        .map(l => normalizeString(l))
        .filter(Boolean);
    }

    /* ----------------------------------------------------------------
       DEFAULT REGLER (fallback)
       Disse bruges KUN hvis filen ikke kan indlæses eller er ugyldig.
       Til daglig vedligeholdelse skal reglerne ændres i filen:
         assets/pdp-delivery-rules.json
       Hold denne fallback nogenlunde i sync med JSON-filen, så siden
       stadig viser fornuftige leveringstider hvis filen fejler.
       ---------------------------------------------------------------- */
    const DEFAULT_RULES = {
      "Adventure Food": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Aetrex": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Beco": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Black+Blum": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Brusletto": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Buddy Swim": { jt_in: "1-3 hverdage", jt_out: "10 hverdage", all_out: "2-3 uger" },
      "Bug Bite": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "CamelBak": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Carex": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Carinthia": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Carson": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Cebé": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Cocoon": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Coghlans": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Compeed": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Cratoni": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Cuddlebug": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Diana Sport": { jt_in: "1-3 hverdage", jt_out: "Udsolgt", all_out: "Udsolgt" },
      "DiFold": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Edelrid": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Edelweiss": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Emergency Food": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Euro Trail": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Feuerhand": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Firepot": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Gainomax": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Gerber": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Gibbon": { jt_in: "1-3 hverdage", jt_out: "10 hverdage", all_out: "Udsolgt" },
      "GloveGlu": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Grangers": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Gränsfors": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Hallmark": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Helsport": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Icebug": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Idento": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Joe Nimble": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Klean Freak": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "La Siesta": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "Udsolgt" },
      "LifeStraw": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "LifeSystems": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "LifeVenture": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "LittleLife": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Lundhags": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Malmsten": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Masters": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Mikasa": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "Udsolgt" },
      "Montane": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Morakniv": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Mountain Paws": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Muurikka": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Nemo": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Nikwax": { jt_in: "1-3 hverdage", jt_out: "5 hverdage", all_out: "2-3 uger" },
      "Nordic Grip": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Ortho Movement": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Petromax": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Red Chili": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Rehband": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Sealskinz": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Silva": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "SmellWell": { jt_in: "1-3 hverdage", jt_out: "4-8 hverdage", all_out: "2-3 uger" },
      "Spibelt": { jt_in: "1-3 hverdage", jt_out: "10 hverdage", all_out: "2-3 uger" },
      "Springyard": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Stubai": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Swix": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Tasmanian Tiger": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Tatonka": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Tentipi": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Ticket to The Moon": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "Toko": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Travelsafe": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Ulvang": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Vaude": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Winnerwell": { jt_in: "1-3 hverdage", jt_out: "Bestillingsvare, spørg på leveringstid", all_out: "Bestillingsvare, spørg på leveringstid" },
      "ZlideOn": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" },
      "Øyo": { jt_in: "1-3 hverdage", jt_out: "1-3 hverdage", all_out: "2-3 uger" }
    };

    // Brug reglerne fra pdp-delivery-rules.json hvis de er indlæst,
    // ellers fald tilbage til DEFAULT_RULES ovenfor.
    const RULES = LOADED_RULES || DEFAULT_RULES;

    const NORMALIZED_RULES = Object.fromEntries(
      Object.entries(RULES).map(([key, value]) => [
        normalizeString(key),
        value
      ])
    );

    const r = NORMALIZED_RULES[vendor];

    let msg = "";

    // Egne lagre: JT Sport + Webpakkeriet (3PL for Nikwax siden 24.09.2026)
    const OWN_LOCATIONS = ["JT Sport", "Nikwax (Webpakkeriet)"];

    if (!r) {
      msg = locations.length ? "1-3 hverdage" : "Udsolgt";
    } else if (OWN_LOCATIONS.some((l) => locations.includes(normalizeString(l)))) {
      msg = r.jt_in;
    } else if (locations.length > 0) {
      msg = r.jt_out || r.jt_in;
    } else {
      msg = r.all_out || "Udsolgt";
    }

    el.textContent = msg;
  }

  function init() {
    // Hent reglerne først, så vi ikke når at vise en forkert leveringstid
    // og derefter rette den (undgår "flash" for kunden). loadRules afviser
    // aldrig – ved fejl bruges fallback.
    loadRules().then(() => {
      updateInventoryMessage();

      document.addEventListener("variant:change", updateInventoryMessage);

      document.addEventListener("change", e => {
        if (e.target && e.target.name === "id") {
          updateInventoryMessage();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
